import { API_ROUTES } from "../config";
import { http } from "../http";

// ─── Floor Layouts ────────────────────────────────────────────────────────────

export const getFloorLayoutsService = async () => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-floor-layouts"]);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

// ─── Sections ─────────────────────────────────────────────────────────────────

export const getSectionsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-sections"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

// ─── Seats ────────────────────────────────────────────────────────────────────

export const getSeatsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-seats"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const searchSeatsService = async (params) => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-seats-search"], { params });
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

// ─── Bookings ─────────────────────────────────────────────────────────────────

export const getBookingsService = async () => {
    try {
        const responseData = await http().get(API_ROUTES["seat-management-bookings"]);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createBookingService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["seat-management-bookings"], data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelBookingService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["seat-management-bookings"]}/${id}/cancel`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const createRecurringBookingService = async (data) => {
    try {
        const responseData = await http().post(`${API_ROUTES["seat-management-bookings"]}/recurring`, data);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};

export const cancelRecurringBookingService = async (id) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["seat-management-bookings"]}/recurring/${id}`);
        return responseData;
    } catch (err) {
        console.log("err", err);
        throw err;
    }
};
